import { StatusBanner, Text } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSearchParams } from "react-router";
import { dataSourceSlugToName } from "shared-ui";

import type { OAuthErrorMessage } from "../message-definitions";
import { MESSAGES, OAUTH_ERROR_MESSAGES } from "../message-definitions";

export const OAuthErrorBanner = ({ connectorSlug }: { connectorSlug: string }) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const oAuthError = searchParams.get("oauth-error");
  const errorMessageFromOAuthKey = (() => {
    // Customer came back from OAuth flow via third party platform back button
    if (oAuthError) {
      const messageKey = oAuthError in OAUTH_ERROR_MESSAGES ? oAuthError : "default";
      return intl.formatMessage(OAUTH_ERROR_MESSAGES[messageKey as OAuthErrorMessage], {
        dataSourceName: dataSourceSlugToName(connectorSlug),
      });
    } else {
      return undefined;
    }
  })();
  const [error] = useState(errorMessageFromOAuthKey);

  const bannerBody = (
    <>
      <Text>
        {intl.formatMessage(MESSAGES.oauthErrorBannerWeEncountered)} {error}
      </Text>
      <Text>{intl.formatMessage(MESSAGES.oauthErrorBannerTryAgain)}</Text>
    </>
  );

  return (
    error && (
      <StatusBanner
        title={intl.formatMessage(MESSAGES.oauthErrorBannerTitle)}
        subheading={bannerBody}
        variant="critical"
      />
    )
  );
};
